import { BrandSettings } from '.'

export const shipcamps: BrandSettings = {
  id: 'shipcamps',
  name: 'ShipCamps',
  colors: {
    primary: 'off-shore-navy',
    secondary: 'shipcamps-brown',
    'accent-1': 'background-brown',
    'accent-2': 'button-hover-state',
    'accent-3': 'sun-chaser-yellow',
    'accent-4': 'pool-side-blue',
    accessibility: 'accessible-camps',
  },
  logo: {
    primary: 'shipcamps',
    dark: 'shipcampsdark',
    textOnly: 'shipcamps',
    textOnlyDark: 'shipcampstextonlydark',
  },
  tripTypes: ['roundtrip', 'oneway-to-camp', 'oneway-from-camp'],
}

export const shipgo: BrandSettings = {
  id: 'shipgo',
  name: 'ShipGo',
  colors: {
    primary: 'logo-background',
    secondary: 'logo-highlights',
    'accent-1': 'background-highlights',
    'accent-2': 'button-hover-state',
    'accent-3': 'shipgo-red',
    'accent-4': 'button-links',
    accessibility: 'accessible-ship-go',
  },
  logo: {
    primary: 'shipgo',
    dark: 'shipgodark',
    textOnly: 'shipgo',
    textOnlyDark: 'shipgodark',
  },
  tripTypes: ['roundtrip', 'oneway', 'multi'],
}

export const shipplay: BrandSettings = {
  id: 'shipplay',
  name: 'Ship & Play',
  colors: {
    primary: 'off-shore-navy',
    secondary: 'tee-box-green',
    'accent-1': 'background-green',
    'accent-2': 'button-hover-state',
    'accent-3': 'sun-chaser-yellow',
    'accent-4': 'pool-side-blue',
    accessibility: 'accessible-green',
  },
  logo: {
    primary: 'shipplay',
    dark: 'shipplaydark',
    textOnly: 'shipplaytextonly',
    textOnlyDark: 'shipplaytextonlydark',
  },
  tripTypes: ['roundtrip', 'oneway', 'multi'],
}

export const shipschools: BrandSettings = {
  id: 'shipschools',
  name: 'ShipSchools',
  colors: {
    primary: 'off-shore-navy',
    secondary: 'sun-chaser-yellow',
    'accent-1': 'background-yellow',
    'accent-2': 'button-hover-state',
    'accent-3': 'acedemic-slate-blue',
    'accent-4': 'pool-side-blue',
    accessibility: 'accessible-schools',
  },
  logo: {
    primary: 'shipschools',
    dark: 'shipschoolsdark',
    textOnly: 'shipschools',
    textOnlyDark: 'shipschoolstextonlydark',
  },
  tripTypes: ['roundtrip', 'oneway', 'multi'],
}

export const shipskis: BrandSettings = {
  id: 'shipskis',
  name: 'ShipSkis',
  colors: {
    primary: 'off-shore-navy',
    secondary: 'alpine-blue',
    'accent-1': 'background-blue',
    'accent-2': 'button-hover-state',
    'accent-3': 'sun-chaser-yellow',
    'accent-4': 'pool-side-blue',
    accessibility: 'accessible-skis',
  },
  logo: {
    primary: 'shipskis',
    dark: 'shipskisdark',
    textOnly: 'shipskis',
    textOnlyDark: 'shipskistextonlydark',
  },
  tripTypes: ['roundtrip', 'oneway'],
}

export const shipsticks: BrandSettings = {
  id: 'shipsticks',
  name: 'ShipSticks',
  colors: {
    primary: 'off-shore-navy',
    secondary: 'tee-box-green',
    'accent-1': 'background-green',
    'accent-2': 'button-hover-state',
    'accent-3': 'sun-chaser-yellow',
    'accent-4': 'pool-side-blue',
    accessibility: 'accessible-green',
  },
  logo: {
    primary: 'shipsticks',
    dark: 'shipsticksdark',
    textOnly: 'shipstickstextonly',
    textOnlyDark: 'shipstickstextonlydark',
  },
  // Temporarily remove multi city
  tripTypes: ['roundtrip', 'oneway'],
}

export const luggagefree: BrandSettings = {
  id: 'luggagefree',
  name: 'LuggageFree',
  colors: {
    primary: 'lf-blue',
    secondary: 'lf-gray-blue',
    'accent-1': 'lf-light-gray-blue',
    'accent-2': 'button-hover-state',
    'accent-3': 'callout',
    'accent-4': 'accent-link',
    accessibility: 'accessible-lf',
  },
  logo: {
    primary: 'luggagefree',
    dark: 'luggagefreedark',
    textOnly: 'luggagefree',
    textOnlyDark: 'luggagefreedark',
  },
  tripTypes: ['roundtrip', 'oneway', 'multi'],
}

export const subBrandSettings = [
  shipcamps,
  shipgo,
  shipplay,
  shipschools,
  shipskis,
  shipsticks,
  luggagefree,
]

export const subBrands = Object.fromEntries(
  subBrandSettings.map((subBrand) => [subBrand.id, subBrand]),
)
